import { request, request2 } from '../utils/request'
import { querystring } from '../utils/index'

export default {
  getoutstockorders: option =>
    request('v1/outstockorder/getoutstockorders', option, true, false), // 出库订单列表
  getoutstockorder: option => {
    const urls = querystring(option)
    return request('v1/outstockorder/getoutstockorder' + urls, {}, true, false) // 查询出库订单
  },
  getoutstocks: option =>
    request('v1/outstock/getoutstocks', option, true, false), // 出库记录列表
  getoutstock: option => {
    const urls = querystring(option)
    return request('v1/outstock/getoutstock' + urls, {}, true, false) // 查询出库单详情
  },
  addoutstockorder: option =>
    request('v1/outstockorder/addoutstockorder', option, true, false), // 新增出库订单
  deleteoutstockorder: option => {
    const urls = querystring(option)
    return request('v1/outstockorder/deleteoutstockorder' + urls, {}, true, false) //  删除出库订单
  },
  closeoutstockorder: option => {
    const urls = querystring(option)
    return request('v1/outstockorder/closeoutstockorder' + urls, {}, true, false) //  关闭出库订单
  },
  getwarehouses: option =>
    request('v1/warehouse/getwarehouses', option, true, false), // 查仓库列表
  updatewarehouse: option =>
    request('v1/warehouse/updatewarehouse', option, true, false), // 查仓库列表

  setweightandvolume: option => {
    const urls = querystring(option)
    return request('oms/send/setweightandvolume' + urls, option, true, false) // 查询出库单详情
  },
  getoutlist: option =>
    request('oms/out/list', option, true, false), // 出库单列表
  getsaleslist: option =>
    request('oms/sales/list', option, true, false), // 订单列表
  getsendlist: option =>
    request('oms/send/list', option, true, false), // 发货单列表

  uploadsales: option => request('oms/sales/upload', option, true, true), // 上传订单
  salesremark: option => request('oms/sales/remark', option, true, false), // 订单修改备注
  salesadd: option =>
    request('oms/sales/add', option, true, false), // 新增订单

  deaudit: option =>
    request('oms/sales/deaudit', option, true, false), // 反审核
  salesfinish: option =>
    request('oms/sales/finish', option, true, false), // 完成订单
  salescancel: option =>
    request('oms/sales/cancel', option, true, false), // 取消订单
  salesdelete: option =>
    request('oms/sales/delete', option, true, false), // 取消订单
  salesdetail: option =>
    request2('oms/sales/detail/' + option.salesOrderId, true, false), // 新增订单
  stocklist: option =>
    request('oms/stock/list', option, true, false), // 新增订单
  salesouttypeaudit: option =>
    request('oms/sales/out_type_audit', option, true, false), // 审核订单
  salesbatchaudit: option =>
    request('oms/sales/batch_audit', option, true, false), // 审核订单
  outadd: option =>
    request('oms/out/add', option, true, false), // 出库单新增
  sendadd: option =>
    request('oms/send/add', option, true, false), // 发货单新增
  outsendadd: option =>
    request('oms/out/out_send', option, true, false), // 出库单新增并发货单
  addbysalesorder: option =>
    request('oms/out/add_by_sales_order', option, true, false), // 批量出库单新增
  hascombineddelivery: option =>
    request('oms/out/has_combined_delivery ', option, true, false), // 批量出库单可合并订单信息
  outcancel: option =>
    request('oms/out/out_cancel', option, true, false), // 出库单新增
  outdetail: option =>
    request2('oms/out/detail/' + option.outOrderId, true, false), // 出库单详情
  tallyorderlist: option =>
    request('oms/tally/order/list', option, true, false), // 理货单列表
  tallyorderprint: option =>
    request2('oms/tally/order/print/' + option.tallyOrderId, true, false), // 理货单详情
  tallyorderdetail: option =>
    request2('oms/tally/order/detail/' + option.tallyOrderId, true, false), // 理货单详情
  tallyorderitemlist: option =>
    request('oms/tally/order/item/list', option, true, false), // 查询待创建理货单的出库记录
  tallyorderadd: option =>
    request('oms/tally/order/add', option, true, false), // 理货单新增
  checkorderlist: option =>
    request('oms/check/order/list', option, true, false), // 盘库单列表
  checkorderdetail: option =>
    request2('oms/check/order/detail/' + option.checkOrderId, true, false), // 盘库单详情
  expressprint: option =>
    request('oms/out/express/print', option, true, false), // 打印面单
  sendlist: option =>
    request('oms/out/send/list', option, true, false), // 查询发货信息(打印模板等)
  refundlist: option =>
    request('oms/sales/refund/list', option, true, false), // 退货单列表
  refunddetail: option =>
    request2('oms/sales/refund/detail/' + option.refundOrderId, true, false), // 退货单详情
  allocatelist: option =>
    request('oms/stock/allocate/list', option, true, false), // 调拨单列表
  allocatedetail: option =>
    request2('oms/stock/allocate/detail/' + option.allocateOrderId, true, false), // 调拨单详情
  allocateaudit: option =>
    request('oms/stock/allocate/audit', option, true, false), // 审核调拨单
  allocateadd: option =>
    request('oms/stock/allocate/add', option, true, false), // 审核调拨单
  allocatefinish: option =>
    request('oms/stock/allocate/finish', option, true, false), // 关闭调拨单
  allocatedeaudit: option =>
    request('oms/stock/allocate/deaudit', option, true, false), // 关闭调拨单
  downloadorders: option =>
    request('oms/sales/downloadorders', option, true, false, true), // 订单导出
  downloadcouriers: option =>
    request('oms/out/downloadcouriers', option, true, false, true), // 导出物流单
  downloadoutorders: option =>
    request('oms/tally/order/downloadoutorders', option, true, false, true), // 导出理货单明细

  getoutstocktags: option => {
    const urls = querystring(option)
    return request('v1/outstock/getoutstocktags' + urls, {}, true, false) // 查询出库单详情
  },
  confirmallreturn: option =>
    request('oms/sales/confirmallreturn', option, true, false), // 退单确认

  calcapisign: option => request('v1/doudian/calcapisign', option) // 获取时间戳签名数据
}
